module.exports = __webpack_public_path__ + "media/short_loop-720p.dd1eb490.mp4";